import { HttpClient, HttpParams } from '@angular/common/http';
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import {
    UserModelInterface,
    UserModelResponse,
} from 'src/app/interface/user-model.interface';

@Component({
    selector: 'app-component-form-search-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css'],
})
export class UserComponent implements OnChanges {
    @Input() public originalValue?: string;
    public userControl = new FormControl();
    public userResults: UserModelInterface[] = [];
    public selectedUser?: UserModelInterface;
    @Output() public userChanged = new EventEmitter();

    constructor(private httpClient: HttpClient) {}

    ngOnChanges(): void {
        this.userControl.setValue('');
        if (this.originalValue) {
            this.userControl.setValue(this.originalValue);
        }

        this.userControl.valueChanges
            .pipe(debounceTime(300), distinctUntilChanged())
            .subscribe((query: string) => {
                this.getSearchResults();
            });
    }

    public clearSelectedUser() {
        this.selectedUser = undefined;
        this.userControl.setValue('');
        this.userChanged.emit(undefined);
    }

    private getSearchResults() {
        let params = new HttpParams()
            .set('limit', 4)
            .set('search', this.userControl.value);
        this.httpClient
            .get<UserModelResponse>('users', {
                params: params,
            })
            .subscribe((response: UserModelResponse) => {
                this.userResults = response.results;
            });
    }

    public setHiddenValues(event: any) {
        this.selectedUser = undefined;
        let users = this.userResults.filter(
            (user) => user.email == event.option.value
        );

        if (users.length) {
            this.selectedUser = users[0];
            this.userChanged.emit(this.selectedUser);
        }
    }
}
